export default __webpack_public_path__ + "static/media/615.c59f7864.png";